import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "./Contact.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant } from "../../Helper/Api";

// Properties
const properties = require("../../properties.json");

// The reference design's Contact page had a message form too -- dropped by the teacher's own
// request (contact info + social links only), so this page is just the info card.
const SOCIAL_LINKS = [
  { key: "facebookUrl", icon: "fab fa-facebook-f", label: "Facebook" },
  { key: "instagramUrl", icon: "fab fa-instagram", label: "Instagram" },
  { key: "linkedinUrl", icon: "fab fa-linkedin-in", label: "LinkedIn" },
  { key: "behanceUrl", icon: "fab fa-behance", label: "Behance" },
];

class Contact extends Component {
  state = {
    tenant: null,
    notFound: false,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = tenant.name ? `Contact | ${tenant.name}` : properties.site_name;
        this.setState({ tenant });
      })
      .catch(() => this.setState({ notFound: true }));
  }

  render() {
    const { tenant, notFound } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    const activeSocials = SOCIAL_LINKS.filter((s) => tenant[s.key]);

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="nd-eyebrow">Get in Touch</div>
              <h1>Contact</h1>
              <p>Questions about a course, a project, or a workshop? Send a message and we'll get back to you.</p>
            </div>
          </div>

          <div className="nd-section nd-wrap">
            <div className="contact-card">
              <h3>Contact Info</h3>

              {tenant.email && (
                <div className="c-row">
                  <div className="c-icon"><i className="fas fa-envelope"></i></div>
                  <div>
                    <div className="c-label">Email</div>
                    <div className="c-value">{tenant.email}</div>
                  </div>
                </div>
              )}

              {tenant.mobile && (
                <div className="c-row">
                  <div className="c-icon"><i className="fas fa-phone"></i></div>
                  <div>
                    <div className="c-label">Phone</div>
                    <div className="c-value">{tenant.mobile}</div>
                  </div>
                </div>
              )}

              {tenant.location && (
                <div className="c-row">
                  <div className="c-icon"><i className="fas fa-map-marker-alt"></i></div>
                  <div>
                    <div className="c-label">Location</div>
                    <div className="c-value">{tenant.location}</div>
                  </div>
                </div>
              )}

              {activeSocials.length > 0 && (
                <div className="social-row">
                  {activeSocials.map((s) => (
                    <a href={tenant[s.key]} target="_blank" rel="noopener noreferrer" key={s.key} aria-label={s.label}>
                      <i className={s.icon}></i>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Contact;
